<div class="pdf-viewer">
  <ngx-extended-pdf-viewer
    [src]="pdfSrc"
    [showZoomButtons]="false"
    [showFindButton]="false"
    [showPagingButtons]="true"
    [showPresentationModeButton]="false"
    [showOpenFileButton]="false"
    [showPrintButton]="false"
    [showDownloadButton]="false"
    [showSecondaryToolbarButton]="false"
    [showRotateButton]="false"
    [showHandToolButton]="false"
    [showSpreadButton]="false"
    [showPropertiesButton]="false"
    [showSidebarButton]="false"
    [showBorders]="false"
    [showTextEditor]="false"
    [showDrawEditor]="false"
    [backgroundColor]="'#999'"
    [showScrollingButton]="false"
    [sidebarVisible]="false"
    showSidebarOnLoad="false"
    [handTool]="false"
    [textLayer]="false"
    [zoom]="'100%'"
    [maxZoom]="1"
    [minZoom]="1"
    [page]="pageSelected"
    [enablePrint]="false"
    [acceptKeys]="['CTRL+P']"
    (pagesLoaded)="onPagesLoaded($event)"
    (pageChange)="onPageChangeByViewer($event)"
    useBrowserLocale="true"
    [height]="'calc(100vh - 165px)'"
    [showUnverifiedSignatures]="true">
    
  </ngx-extended-pdf-viewer>

  <div *ngIf="this.withRubrics" >
    <div *ngFor="let config of fileValidateService.fileConfig" >
      <div class="rubrics-section d-flex justify-content-end" id="{{ config.fileName }}" style="display: none !important">
        <div class="rubrics" id="{{ config.page }}">
          <div *ngFor="let item of filterPages(config); let i = index" class="rubric" id="{{ config.page }}"
            [attr.data-id]="item.signatoryId" [attr.gId]="item.gId">
            <img src="{{ item.stamp }}" class="rubric-image"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modalOnBoarding></ng-template>

<cdx-onboarding-tour
  onboardingId="onboardingSignPosition"
  *ngIf="showOnBoardingPosition" 
  [options]="onBoardingSignPosition" 
  (onCloseTour)="handleClosePositionTour()">
</cdx-onboarding-tour>
